import * as pdf from './pdf';
import * as auth from './auth';
import * as tenants from './tenants';

export * from './instance';
export * from './constants';

export const api = {
  pdf,
  auth,
  tenants,
};
